import { logWrapper } from '../utils';

export default {
  repositoryModel: [
    'runtimeConstant',
    function (runtimeConstant) {
      function Repository(data) {
        this.id = data ? data.Id : 0;
        this.idCompany = data ? data.IdCompany : 0;
        this.name = data ? data.Name : '';
        this.description = data ? data.Description : '';
        this.acronym = data ? data.Acronym : '';
        this.inheritAcronym = data ? data.InheritAcronym : false;

        this.documentTypes =
          data && data.DocumentTypesFolders ? data.DocumentTypesFolders : [];

        this.selected = false;
      }

      function title() {
        return this.name;
      }

      function details() {
        return this.description;
      }

      function tags() {
        return null;
      }

      function isValid() {
        var isValid =
          this.name !== undefined &&
          this.name !== null &&
          this.name.trim() !== '';
        return isValid;
      }

      function toggleAllRoles(value) {
        if (arguments.length > 0) {
          this.allDocumentTypes.forEach(function (d) {
            d.selected = value;
          });
        } else {
          if (
            this.allDocumentTypes === undefined ||
            this.allDocumentTypes === null
          ) {
            return false;
          }

          return this.allDocumentTypes.every(function (d) {
            return d.selected === true;
          });
        }
      }

      function run() {
        try {
          Repository.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
            toggleAllRoles: logWrapper(
              toggleAllRoles,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Repository;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
